"use client";

import { useLocale } from "next-intl";
import { useAnalyticsConsent } from "./ConsentProvider";

const labels: Record<string, string> = {
  pt: "Preferências de privacidade",
  en: "Privacy preferences",
  es: "Preferencias de privacidad",
  fr: "Préférences de confidentialité",
  it: "Preferenze sulla privacy",
  de: "Datenschutzeinstellungen",
  ro: "Preferințe de confidențialitate",
};

export function ConsentPreferencesButton() {
  const locale = useLocale().split("-")[0];
  const { openPreferences } = useAnalyticsConsent();

  return (
    <button
      type="button"
      className="text-sm text-muted-foreground transition-colors hover:text-foreground focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ring"
      onClick={openPreferences}
      data-sendbot-consent-preferences
    >
      {labels[locale] ?? labels.en}
    </button>
  );
}
